import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { isInternalURI } from '../helpers/location';
import { breakpoints } from '../constants/mediaqueries';
import { fluidPropTypes } from '../types';

import ExternalLink from './ExternalLink';
import ImageTitleCaption from './ImageTitleCaption';
import LocalisedLink from './LocalisedLink';
import MichelbergerImage from './MichelbergerImage';


const Wrapper = styled.div`
  display: block;

  > a {
    display: block;
  }

  @media ${breakpoints.l} {
    width: ${(props) => (props.size === 'medium' ? '50vw' : '70vw')};
    max-width: calc(100vw - 25rem); /* 400/16 */
    margin: 0 auto;
  }
`;

const SingleImageBlock = ({ block, size }) => {
  const { caption, changesColorOnHover, hasBlendMode, image, imageUrl, title } = block;

  const mbImage = (
    <MichelbergerImage
      changesColorOnHover={changesColorOnHover}
      hasBlendMode={hasBlendMode}
      image={image}
    />
  );

  return (
    <Wrapper size={size}>
      <Choose>
        <When condition={imageUrl && isInternalURI(imageUrl)}>
          <LocalisedLink hasUnderline={false} to={imageUrl}>{mbImage}</LocalisedLink>
        </When>
        <When condition={imageUrl}>
          <ExternalLink hasUnderline={false} href={imageUrl}>{mbImage}</ExternalLink>
        </When>
        <Otherwise>
          {mbImage}
        </Otherwise>
      </Choose>
      <ImageTitleCaption caption={caption} title={title} url={imageUrl} />
    </Wrapper>
  );
};

SingleImageBlock.propTypes = {
  block: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    caption: PropTypes.string,
    image: PropTypes.shape({
      id: PropTypes.string,
      mimeType: PropTypes.string,
      url: PropTypes.string,
      fluid: fluidPropTypes,
    }).isRequired,
    imageUrl: PropTypes.string,
    hasBlendMode: PropTypes.bool,
    changesColorOnHover: PropTypes.bool,
  }).isRequired,
  size: PropTypes.string.isRequired,
};

export default SingleImageBlock;
